// extracted by mini-css-extract-plugin
export var adjacentSlide = "_o5-9";
export var arrowButtonContainer = "_o5-5";
export var arrowButtonIcon = "_o5-6";
export var carouselArrowButton = "_o5-2";
export var carouselElementContainer = "_o5-1";
export var currentSlide = "_o5-8";
export var left = "_o5-3";
export var otherSlide = "_o5-a";
export var productCarouselContainer = "_o5-0";
export var right = "_o5-4";
export var sliderOverflow = "_o5-7";